export default {
  Editor: 'Editor',
  Sales: 'Sales',
  Manager: 'Manager',
  Owner: 'Owner',
  Admin: 'Admin',
  User: 'User',
};
